export default {
  model: {
    prop: 'checked',
    event: 'change',
  },
  props: {
    name: {
      type: String,
      required: true,
    },
    required: {
      type: Boolean,
      default: false,
    },
    checked: {
      type: String,
    },
    value: {
      type: String,
      required: false,
    },
    label: {
      type: String,
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    onClick() {
      this.$emit('change', this.value);
    },
    onChange(e) {
      this.$emit('change', e.target.value);
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/forms/radio/radio.js